// extracted by mini-css-extract-plugin
export default {"individualCatalogue":"Catalogue_individualCatalogue__1yw-X","buttonCatalogue":"Catalogue_buttonCatalogue__V0NlX","catalogueImg":"Catalogue_catalogueImg__hYgtJ"};